// React
import { useState, useEffect, memo } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import MainNavigation from './nav/MainNavigation';
// Assets
import kykyLogo from '../assets/kyky-logo.png';
import '../styles/Header.scss';
import styles from '../styles/Burger.module.scss';

// The header changes colors if its position is greater than 40.
// This is to make the header visible when the user scrolls down the page.

const Header = () => {
  const [scrollPosition, setScrollPosition] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (menuOpen) {
      setMenuOpen(false);
    }
  }, [location]);

  const handleScroll = () => {
    const scroll = document.documentElement.scrollTop;
    setScrollPosition(scroll > 40);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={scrollPosition ? 'navigation_bg' : 'navigation_container'}>
      <Link to="/">
        <div className="headerLogo">
          <img className="logoImage" src={kykyLogo} alt="KykyLogo" />
        </div>
      </Link>
      <div className="mainNavContainer">
        <div
          onClick={() => setMenuOpen(!menuOpen)}
          className={menuOpen ? styles.menu_opened : styles.burger_menu}>
          <div className={styles.burger_menu_line1} />
          <div className={styles.burger_menu_line2} />
          <div className={styles.burger_menu_line3} />
        </div>
        <MainNavigation menuOpen={menuOpen} />
      </div>
    </div>
  );
};

export default memo(Header);
